var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8881",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8881",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7486",
    "data-name": "\\u30D1\\u30B9 7486",
    d: "M24,12A12,12,0,1,0,10.125,23.85V15.466H7.078V12h3.047V9.355c0-3.007,1.792-4.668,4.533-4.668a18.456,18.456,0,0,1,2.686.234V7.874H15.831a1.734,1.734,0,0,0-1.956,1.874V12H17.2l-.532,3.468h-2.8V23.85A12,12,0,0,0,24,12Z",
    fill: "#1877f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7487",
    "data-name": "\\u30D1\\u30B9 7487",
    d: "M311.86,211.081l.547-3.565h-3.421V205.2a1.783,1.783,0,0,1,2.01-1.926h1.555v-3.035A18.965,18.965,0,0,0,309.79,200c-2.817,0-4.659,1.707-4.659,4.8v2.717H302v3.565h3.132V219.7a12.464,12.464,0,0,0,3.854,0v-8.618Z",
    transform: "translate(-295.069 -195.849)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1aa5a4bd31207477e803a56f8edb9b32.svg";
export { ForwardRef as ReactComponent };